// extracted by mini-css-extract-plugin
export default {"drawer":"UW","drawerheader":"VW","retake_quiz_bottom_bar":"WW","extra_drawer":"XW","not_answered_questions":"YW","question_ui":"ZW","accordion_details":"aX","retake_quiz":"bX","accordions":"cX","accordion_root":"eX","accordion_summary_text":"fX","animation":"gX","show_animation":"hX","overflow_hidden":"iX"};
    if(module.hot) {
      // 1726593107623
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  